import { mallApi } from '../request'
import { apiPath } from '../api'

export const moneyTree = {
  // 根据活动ID获取用户剩余抽奖次数
  getLotteryCount: data => mallApi.post(apiPath.getLotteryCount, data),
  // 点击抽奖
  getLotteryLuck: data => mallApi.post(apiPath.getLotteryLuck, data),
  // 获取本次活动最近中奖记录
  getLotteryRecords: data => mallApi.post(apiPath.getLotteryRecords, data),
  // 获取我的获奖记录
  getMyLotteryRecords: data => mallApi.post(apiPath.getMyLotteryRecords, data),
  // 获取摇钱树广告位
  getLotteryAds: data => mallApi.post(apiPath.getLotteryAds, data)
}
